module.exports = __webpack_public_path__ + "static/img/card1.74c6b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/card1.png
// module id = x8DL
// module chunks = 0